import { useState } from 'react'

function useForm<Type>(initailValue = {} as Type) {
  const [data, setData] = useState<Type>(initailValue)

  const resetForm = () => setData(initailValue)

  function setAsyncInitData(data) {
    setData(data)
  }

  function handleOnChange(name) {
    return (event) => {
      setData({
        ...data,
        [name]: event.target.value,
      })
    }
  }

  function handleCheckboxOnChange(name) {
    return (event) => {
      setData({
        ...data,
        [name]: event.target.checked,
      })
    }
  }
  return { data, handleOnChange, setAsyncInitData, resetForm, handleCheckboxOnChange }
}

export default useForm
